import React from "react";
import ASSETS from "@/lib/assets";

/**
 * Photo wrapper. If `src` is provided, renders the actual image with cover/position styles.
 * Otherwise falls back to a tasteful placeholder block tinted by `tone`.
 */
const PhotoPlaceholder = ({
  tone = "teal",
  label = "Portrait",
  src,
  position = "top center",
  className = "",
}) => {
  if (src) {
    return (
      <div className={`photo-frame ${className}`} data-testid="photo-real">
        <img
          src={src}
          alt={label}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            objectPosition: position,
            display: "block",
          }}
        />
      </div>
    );
  }
  const toneClass =
    tone === "cream" ? "cream"
    : tone === "coral" ? "coral-bg"
    : tone === "bw" ? "bw"
    : tone === "blue" ? "blue-suit"
    : tone === "pink" ? "hot-pink"
    : "";
  return (
    <div className={`photo-ph ${toneClass} ${className}`} data-testid={`photo-${tone}`}>
      <span className="ph-label">{label}</span>
    </div>
  );
};

export { ASSETS };
export default PhotoPlaceholder;
